export enum ProcessEnum {
  AgreementApprovement = 1,
  EventApproval = 2,
  GeneralApproval = 3
}
